function servicesList() {
  var ps;
  // Скроллбар на меню
  var $servicesList = $('.js-services-list');
  initScrollingMenu($servicesList);
  

  $(document).on('touchstart', function(e){
    ps.destroy();
  }).on('touchend', function(){
    initScrollingMenu($servicesList);
  })

  // Стартовое значение скролла
  $servicesList[0].scrollLeft = 0;

  var coordX;
  var currentScrollLeft;
  var isClicked = null;

  // Драг меню
  $servicesList.on('mousedown', function(e) {
    e.preventDefault();

    coordX = e.pageX;
    currentScrollLeft = $servicesList[0].scrollLeft;

    isClicked = true;
  })

  $('body').on('mousemove', function(e) {
    if (isClicked) {
      $servicesList[0].scrollLeft = currentScrollLeft - (e.pageX - coordX);
      if ($servicesList[0].scrollLeft > 0) {
        $(".main-nav").addClass("has-back-btn");
        $(".js-header-menu-back").css({"display" :"inline-flex"});
      } else {
        $(".main-nav").removeClass("has-back-btn");
        $(".js-header-menu-back").css({"display" :"none"});
      }
    }
  }).on('mouseup', function() {
    isClicked = false;
  });

  // Скролл по клику на "Еще"
  $('.js-header-menu-more').on('click', function(e) {
    e.stopPropagation();
    scroll($(this),$servicesList,"left");
  });
  // Скролл по клику на "Назад"
  $('.js-header-menu-back').on('click', function(e) {
    e.stopPropagation();
    scroll($(this),$servicesList,"right");
  });

  function initScrollingMenu(elem) {
  ps = new PerfectScrollbar(elem[0], {
    suppressScrollY: true
  });
}
}

function scroll(cont,servicesList,direction) {
  var $firstHiddenElem;
  var $this = cont;
  var gradientWidth = 15;
  var rightCoord;
  var leftCoord;
  var difference;
  // Чекаем первый элемент за пределом экрана + ширина кпопки "еще" + градиент этой кнопки и скроллим его правой части
  $($('.js-services-list-item').get().reverse()).each(function() {
    rightCoord = $(this).offset().left + $(this).outerWidth();
    leftCoord = $(this).offset().left;
    switch (direction) {
      case "left":
        if (rightCoord > $(window).outerWidth() - $this.outerWidth() - gradientWidth) {
          $firstHiddenElem = $(this);
          difference = rightCoord - $(window).outerWidth() +
          $this.outerWidth() + gradientWidth + 1;
        }
      break
      case "right":
        if (leftCoord < $this.outerWidth() + gradientWidth) {
          $firstHiddenElem = $(this);
          difference = leftCoord;
        }
      break
    }
  });
  if (!$firstHiddenElem) {
    return;
  }
  switch (direction) {
    case "left":
      servicesList.animate({ scrollLeft: servicesList[0].scrollLeft + difference }, 300);
      if (!$(".main-nav").hasClass("has-back-btn")) {
        $(".main-nav").addClass("has-back-btn");
        $(".js-header-menu-back").css({"display" :"inline-flex"});
      }
    break
    case "right":
      servicesList.animate({ scrollLeft: difference }, 300);
      $(".main-nav").removeClass("has-back-btn");
      $(".js-header-menu-back").css({"display" :"none"});
    break
  }
}
